import SoftionApi from './SoftionApi';
export default SoftionApi;
